import { useNavigate } from 'react-router-dom';
import { FC, useCallback } from 'react';
import { confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { capitalize } from 'lodash';
import { Pluviometro } from '../../@types/pluviometro';
import Agro1Loader from '../../components/Agro1Loader';
import PluviometrosService from '../../services/pluviometros';
import Agro1Toast from '../../components/Agro1Toast';

interface PropTypes {
  item: Pluviometro;
  onStatusChange: () => Promise<void>;
}

const ActionButtons: FC<PropTypes> = ({ item, onStatusChange }) => {
  const navigate = useNavigate();

  const handleInactivate = useCallback(async () => {
    const loaderId = Agro1Loader.show();

    try {
      await PluviometrosService.inactivate(item.id.toString());

      Agro1Toast.show({
        detail: 'Registro inativo com sucesso.',
        severity: 'success',
      });

      await onStatusChange();
    } catch (error) {
      console.error(error);

      Agro1Toast.show({
        detail: 'Falha ao inativar o registro.',
        severity: 'error',
        sticky: true,
      });
    } finally {
      Agro1Loader.close(loaderId);
    }
  }, [item.id, onStatusChange]);

  const handleActivate = useCallback(async () => {
    const loaderId = Agro1Loader.show();

    try {
      await PluviometrosService.activate(item.id.toString());

      Agro1Toast.show({
        detail: 'Registro ativo com sucesso.',
        severity: 'success',
      });

      await onStatusChange();
    } catch (error) {
      console.error(error);

      Agro1Toast.show({
        detail: 'Falha ao reativar o registro.',
        severity: 'error',
        sticky: true,
      });
    } finally {
      Agro1Loader.close(loaderId);
    }
  }, [item.id, onStatusChange]);

  const requestHandleStatusChange = useCallback(
    (action: 'activate' | 'inactivate', accept: () => Promise<void>) => {
      const humanizedType = action === 'activate' ? 'ativar' : 'inativar';
      const message = `Você tem certeza que deseja ${humanizedType}?`;
      confirmDialog({
        message,
        header: 'Atenção',
        icon: 'pi pi-info-circle',
        accept,
        acceptLabel: capitalize(humanizedType),
        rejectLabel: 'Cancelar',
        acceptClassName: 'button-danger',
        rejectClassName: 'button-primary',
      });
    },
    [],
  );

  return (
    <div className="flex flex-column xl:flex-row">
      <Button
        className="button-secondary ml-auto xl:mr-1"
        icon={item.stAtivo === 'S' ? 'pi pi-trash' : 'pi pi-refresh'}
        severity="success"
        onClick={() =>
          item.stAtivo === 'S'
            ? requestHandleStatusChange('inactivate', handleInactivate)
            : requestHandleStatusChange('activate', handleActivate)
        }
      />
      <Button
        className="button-secondary mr-auto mt-1 xl:mt-0"
        icon="pi pi-pencil"
        severity="success"
        onClick={() =>
          navigate(`/gerenciador-dados/pluviometros/edit/${item.id}`)
        }
      />
    </div>
  );
};

export default ActionButtons;
